import React, { useEffect, useCallback } from 'react'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import './embla.css'
import image1 from '../assets/MenuCalculators/Laser P.png'
import image2 from '../assets/MenuCalculators/Fibre_Optics_P.webp'
import image3 from '../assets/MenuCalculators/Diffuse_Reflection_P.webp'
import image4 from '../assets/MenuCalculators/LookUp_Table_P.webp'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import { useTranslation } from 'react-i18next'


const EmblaCarousel = (props) => {
    const { t } = useTranslation()
    const content = [
        {
            title: t('10038'), //Point and Extended
            description: t('10042'), // The point source has a laser emission from a single point and has a miniscule diameter compared with the viewing distance while an extended source is the opposite with laser emitted from various points and a relatively large diameter.
            image: "/images/Laser_P.webp",
            alt: "Point & Extended"
        },
        {
            title: t('10039'), //Fiber Optic
            description: t('10043'), //utilises flexible quartz or glass fibres that use total internal reflection to pass light through thousands of glancing reflections. Optical sources typically used are laser diodes, LEDs and VCSEL (Vertical Cavity Surface Emitting Laser).
            image: image2,
            alt: "Fiber Optic"
        },
        {
            title: t('10040'), //Diffuse Reflection
            description: t('10044'), //This happens when different parts of a beam strike a surface and reflects over a wide range of angles. The reflection typically strikes a rough or irregular surface.
            image: image3,
            alt: "Diffuse Reflection"
        },
        {
            title: t('10041'), // Lookup Table
            description: t('10045'), // Find out the accessible emission limit for all laser class in relation to the laser wavelength you want to calculate. Evaluate the laser properties to determine safety values for eye and skin.
            image: image4,
            alt: "Lookup Table"
        }
    ]
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 3000, stopOnInteraction: false })])

    useEffect(() => {
        if (!emblaApi) return

        const updateSlideClasses = () => {
            const selectedIndex = emblaApi.selectedScrollSnap()
            const slideNodes = emblaApi.slideNodes()
            const slideCount = slideNodes.length

            const prevIndex = (selectedIndex - 1 + slideCount) % slideCount
            const nextIndex = (selectedIndex + 1) % slideCount

            slideNodes.forEach((slide, index) => {
                slide.classList.remove("is-prev", "is-next")
                if (index === prevIndex) slide.classList.add("is-prev")
                if (index === nextIndex) slide.classList.add("is-next")
            })
        }

        emblaApi.on("select", updateSlideClasses)
        updateSlideClasses()
    }, [emblaApi])

    const onNavButtonClick = useCallback((emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }, [])

    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
        emblaApi,
        onNavButtonClick
    )

    return (
        <section className="embla">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {content.map((content, index) => (
                        <div className="embla__slide" key={index}>
                            <div className="embla__slide__number">
                                <div id="card_content" className='card_content' onMouseEnter={() => emblaApi?.plugins()?.autoplay.stop()} onMouseLeave={() => emblaApi?.plugins()?.autoplay.play()}>
                                    {<img
                                        src={content.image}
                                        alt={content.alt}
                                        width={"100%"}
                                        loading={index === 0 ? "eager" : "lazy"}
                                        // fetchpriority={index === 0 ? "high" : "auto"}
                                    />}
                                    <div class='description_box'>
                                        <div >
                                            <h1>{content.title}</h1>
                                            <p>{content.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="embla__controls">
                <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            onClick={() => onDotButtonClick(index)}
                            className={'embla__dot'.concat(
                                index === selectedIndex ? ' embla__dot--selected' : ''
                            )}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default EmblaCarousel
